import { PublicClientApplication } from '@azure/msal-browser';

export const authKeys = {
  all: ['auth'] as const,
  permissions: (accountId?: string) => [...authKeys.all, 'permissions', accountId] as const,
  roles: (accountId?: string) => [...authKeys.all, 'roles', accountId] as const,
} as const;

/**
 * Acquire access token for API requests with automatic fallback to popup
 */
export async function acquireAccessToken(
  msalInstance: PublicClientApplication,
  scopes: string[]
): Promise<string> {
  const account = msalInstance.getActiveAccount();
  if (!account) {
    throw new Error('No active account');
  }

  try {
    const response = await msalInstance.acquireTokenSilent({
      scopes,
      account,
      forceRefresh: false,
      redirectUri: window.location.origin,
    });
    return response.accessToken;
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : String(error);

    // Handle iframe timeout by using popup immediately
    if (errorMessage.includes('timeout') || errorMessage.includes('iframe') || errorMessage.includes('monitor_window_timeout')) {
      console.warn('Iframe timeout detected, using popup instead');
      const response = await msalInstance.acquireTokenPopup({scopes, account});
      return response.accessToken;
    }

    // For other silent acquisition failures, try popup
    console.warn('Silent token acquisition failed, attempting popup');
    const response = await msalInstance.acquireTokenPopup({scopes, account});
    return response.accessToken;
  }
}